import { MAX_COMMENT_LENGTH } from '@/features/approving_invoice_reports/components/ConfirmRejectModal/constant';
import { ConfirmRejectForm } from '@/features/approving_invoice_reports/components/ConfirmRejectModal/types';
import { useTranslation } from '@/i18n';
import { FormTextArea } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, useMemo } from 'react';
import { Control, useFormState, useWatch } from 'react-hook-form';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);
export type TCommentFieldProps = {
  control: Control<ConfirmRejectForm>;
};

export const CommentField: FC<TCommentFieldProps> = ({ control }) => {
  const { t } = useTranslation();

  const value = useWatch({ control, name: 'comment' });
  const isError = useFormState({ control, name: 'comment' })?.errors?.comment;

  const contentRules = useMemo(
    () => ({
      maxLength: {
        value: MAX_COMMENT_LENGTH,
        message: t('common.validation.max_length', {
          maxLength: MAX_COMMENT_LENGTH,
        }),
      },
    }),
    [t]
  );

  const contentProps = useMemo(
    () => ({
      style: {
        minHeight: '30px',
      },
      autoSize: { minRows: 1 },
      placeholder: t(
        'approving_invoice_reports.reject_modal.comment.placeholder'
      ),
    }),
    [t]
  );
  return (
    <div className={cx('container')}>
      <FormTextArea<ConfirmRejectForm>
        name='comment'
        control={control}
        inputId='comment'
        textAreaProps={contentProps}
        rules={contentRules}
      />
      <div className={cx('count-container', { 'error-container': isError })}>
        <span className={cx('count-text', { 'error-text': isError })}>
          {value?.length} / {MAX_COMMENT_LENGTH}
        </span>
      </div>
    </div>
  );
};

CommentField.displayName = 'CommentField';
